import { render, staticRenderFns } from "./restore-data-popup.html?vue&type=template&id=099e6cfc&scoped=true&external"
import script from "./restore-data-popup.js?vue&type=script&lang=js&external"
export * from "./restore-data-popup.js?vue&type=script&lang=js&external"
import style0 from "./restore-data-popup.scss?vue&type=style&index=0&id=099e6cfc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099e6cfc",
  null
  
)

export default component.exports